import React, { useState } from "react";
import { Card, Table, Form, Row, Col, Dropdown } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { FiCalendar } from "react-icons/fi";

const LeaveList = ({ data = [], onEdit = () => {}, onDelete = () => {} }) => {
  const [search, setSearch] = useState("");
  const [leaveType, setLeaveType] = useState("Leave Type");
  const [sortBy, setSortBy] = useState("Last 7 Days");
  const [rows, setRows] = useState(10);
  const filtered = data.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()),
  );
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");
  const [range, setRange] = useState("04/17/2026 - 04/23/2026");

  const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];

  const handleSelect = (item) => {
    setSelected(item);
    setOpen(false);

    // 🔥 SIMPLE DATE LOGIC (you can replace with real API)
    const today = new Date();
    let from = new Date();

    switch (item) {
      case "Today":
        from = today;
        break;
      case "Yesterday":
        from = new Date(today.setDate(today.getDate() - 1));
        break;
      case "Last 7 Days":
        from = new Date(today.setDate(today.getDate() - 6));
        break;
      case "Last 30 Days":
        from = new Date(today.setDate(today.getDate() - 29));
        break;
      default:
        break;
    }

    const format = (d) =>
      `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
        d.getDate(),
      ).padStart(2, "0")}/${d.getFullYear()}`;

    setRange(`${format(from)} - ${format(new Date())}`);
  };
  return (
    <>
      <Card className="mt-4 leaves-list">
        {/* TOP HEADER */}
        <Card.Header
          style={{
            padding: "16px",
            backgroundColor: "#ffffff",
            // borderBottom: "1px solid #eee",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <h5 style={{ margin: 0, fontWeight: 600 }}>Leave List</h5>

            {/* RIGHT FILTERS */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {/* DATE RANGE */}
              <div style={{ position: "relative" }}>
                {/* INPUT */}
                <div
                  onClick={() => setOpen(!open)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e5e7eb",
                    borderRadius: "1px",
                    padding: "8px 14px",
                    background: "#fff",
                    fontSize: "14px",
                    cursor: "pointer",
                    minWidth: "220px",
                  }}
                >
                  <FiCalendar style={{ marginRight: "8px" }} />
                  {range}
                </div>

                {/* DROPDOWN */}
                {open && (
                  <div
                    style={{
                      position: "absolute",
                      top: "110%",
                      left: 0,
                      width: "220px",
                      background: "#fff",
                      borderRadius: "1px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #eee",
                      zIndex: 999,
                      padding: "6px 0",
                    }}
                  >
                    {/* ARROW */}
                    <div
                      style={{
                        position: "absolute",
                        top: "-6px",
                        left: "20px",
                        width: "12px",
                        height: "12px",
                        background: "#fff",
                        transform: "rotate(45deg)",
                        borderLeft: "1px solid #eee",
                        borderTop: "1px solid #eee",
                      }}
                    />

                    {options.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handleSelect(item)}
                        style={{
                          padding: "10px 14px",
                          fontSize: "14px",
                          cursor: "pointer",
                          background:
                            selected === item ? "#f97316" : "transparent",
                          color: selected === item ? "#fff" : "#111",
                        }}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                )}

                {/* MOBILE FIX */}
                <style>
                  {`
        @media (max-width: 768px) {
          div[style*="minWidth: 220px"] {
            width: 100% !important;
          }
        }
        `}
                </style>
              </div>

              {/* LEAVE TYPE */}
              <Dropdown>
                <Dropdown.Toggle className="text-dark p-2 border bg-white custom-toggle ">
                  {leaveType}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown">
                  {["Medical Leave", "Casual Leave", "Annual Leave"].map(
                    (item) => (
                      <Dropdown.Item
                        key={item}
                        active={leaveType === item}
                        onClick={() => setLeaveType(item)}
                      >
                        {item}
                      </Dropdown.Item>
                    ),
                  )}
                </Dropdown.Menu>
              </Dropdown>

              {/* SORT */}
              <Dropdown>
                <Dropdown.Toggle className="text-dark p-2 border bg-white custom-toggle">
                  Sort By : {sortBy}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown">
                  {[
                    "Recently Added",
                    "Ascending",
                    "Descending",
                    "Last Month",
                    "Last 7 Days",
                  ].map((item) => (
                    <Dropdown.Item
                      key={item}
                      active={sortBy === item}
                      onClick={() => setSortBy(item)}
                    >
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Card.Header>

        {/* SECOND ROW */}
        <div
          style={{
            padding: "14px 16px",
            // borderBottom: "1px solid #eee",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {/* ROW PER PAGE */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontSize: "14px" }}>Row Per Page</span>

              <select
                value={rows}
                onChange={(e) => setRows(e.target.value)}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  padding: "4px 8px",
                  fontSize: "14px",
                }}
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
              </select>

              <span style={{ fontSize: "14px" }}>Entries</span>
            </div>

            {/* SEARCH */}
            <Form.Control
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "220px",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                fontSize: "14px",
              }}
            />
          </div>
        </div>

        {/* TABLE */}
        <Card.Body style={{ padding: 0 }}>
          <div style={{ overflowX: "auto" }}>
            <Table hover responsive>
              <thead>
                <tr
                  style={{
                    backgroundColor: "#afb4b9", // light grey like image
                    borderBottom: "1px solid #dee2e6",
                    height: "50px",
                  }}
                >
                  <th></th>

                  <th>Employee</th>

                  <th>Leave Type</th>

                  <th>From</th>

                  <th>To</th>

                  <th>No of Days</th>

                  <th></th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <Form.Check />
                    </td>

                    {/* EMPLOYEE */}
                    <td>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={item.img}
                          alt=""
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                        <div style={{ marginLeft: "10px" }}>
                          <div style={{ fontWeight: 500 }}>{item.name}</div>
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>
                            {item.role}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>{item.type}</td>
                    <td>{item.from}</td>
                    <td>{item.to}</td>
                    <td>{item.days}</td>

                    {/* ACTIONS */}
                    <td>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <FiEdit
                          style={{ cursor: "pointer" }}
                          onClick={() => onEdit(item)}
                        />
                        <FiTrash2
                          style={{ cursor: "pointer" }}
                          onClick={() => onDelete(item)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>

        {/* CUSTOM CSS */}
        <style>
          {`
        .custom-btn {
          background: #fff !important;
          border: 1px solid #e5e7eb !important;
          color: #111 !important;
          font-size: 14px;
          border-radius: 8px !important;
          padding: 6px 12px;
        }
          .custom-toggle {
  font-size: 14px !important;

  border-radius: 5px !important;
  background-color: #fff !important;
  border: 1px solid #dee2e6 !important;
  color: #212529 !important;
}
.leaves-list{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
box-shadow:0 2px 5px rgba(0,0,0,0.05);
}
        .custom-dropdown {
          border-radius: 10px;
          padding: 8px;
          border: 1px solid #eee;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
        }

        .custom-dropdown .dropdown-item {
          border-radius: 6px;
          padding: 8px 10px;
          font-size: 14px;
        }

        .custom-dropdown .dropdown-item.active {
          background: #f97316 !important;
          color: #fff !important;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .custom-btn {
            width: 100%;
          }
        }
        `}
        </style>
      </Card>
    </>
  );
};

export default LeaveList;
